const Button = (
    { text, onClick, className, icon } : 
    { text: string, onClick: any, className?: string | null, icon?: any }
) => {
    return (
        <button className={className ?? ""} onClick={onClick}>{icon}{text}</button>
    );
}

export default Button;